import { Component, EventEmitter, Output, TemplateRef, ViewChild } from "@angular/core";
import { NgbModalRef, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { BookingStatus } from "src/app/core/constants/bookingConstant";
import { BookingService } from "../../services/booking.service";
import { HistoryService } from "../../services/history.service";
import { UserType } from "src/app/core/constants/constants";

@Component({
  selector: "app-driver-list-model",
  standalone: false,
  templateUrl: "./driver-list-model.component.html",
  styleUrl: "./driver-list-model.component.scss"
})
export class DriverListModelComponent {
  acceptRejectModalRef!: NgbModalRef;
  userList: any[] = []; // Generalized list for drivers or pickers
  selectedUser: any = null; // Holds the selected user (driver or picker)
  selectedBooking: any;
  showValidationMessage: boolean = false; // Controls the visibility of the validation message
  mode: UserType.DRIVER | UserType.PICKER = UserType.DRIVER; // Mode to differentiate between driver and picker
  UserType = UserType; // Expose UserType for template use

  @ViewChild("acceptRejectModal") acceptRejectModal!: TemplateRef<any>;
  @Output() changeBookingStatusEvent = new EventEmitter();
  @Output() changeQcBookingStatusEvent = new EventEmitter();

  constructor(public modalService: NgbModal, private readonly historyService: HistoryService, private readonly bookingService: BookingService) {}

  openModal(booking: any, mode: UserType.DRIVER | UserType.PICKER = UserType.DRIVER): void {
    this.selectedBooking = booking;
    this.mode = mode; // Set the mode
    this.getBookingUsers();
    this.acceptRejectModalRef = this.modalService.open(this.acceptRejectModal, { centered: true, backdrop: "static" });
    this.acceptRejectModalRef.result.then(
      () => {},
      () => {}
    );
  }

  onSelectUser(event: any): void {
    this.selectedUser = event; // Update the selected user
    this.showValidationMessage = false; // Hide validation message on selection
  }

  getBookingUsers(): void {
    if (this.mode === UserType.DRIVER) {
      this.historyService.getDriversOfBooking(this.selectedBooking._id).subscribe((res: any) => {
        this.userList = [];
        if (res?.data?.length > 0) {
          this.userList = res?.data.map((user: any) => ({
            ...user,
            fullName: `${user.firstName} ${user.lastName}`
          }));
        }
      });
    } else if (this.mode === UserType.PICKER) {
      this.historyService.getPickersOfBooking(this.selectedBooking._id).subscribe((res: any) => {
        this.userList = [];
        if (res?.data?.length > 0) {
          this.userList = res?.data.map((user: any) => ({
            ...user,
            fullName: `${user.firstName} ${user.lastName}`
          }));
        }
      });
    }
  }

  userAccept(): void {
    if (!this.selectedUser) {
      this.showValidationMessage = true; // Show validation message if no user is selected
      return;
    }
    this.showValidationMessage = false;
    const bookingId = this.selectedBooking._id;
    const userId = this.selectedUser._id;
    if (this.mode === UserType.DRIVER) {
      this.bookingService.driverAccept(bookingId, { bookingId, driverId: userId }).subscribe((res: any) => {
        if (res) {
          const status = res?.data?.status;
          if (status) {
            this.selectedBooking.status = BookingStatus.ACCEPTED;
            this.changeBookingStatusEvent.emit(this.selectedBooking);
          }
          this.closeModal();
        }
      });
    } else {
      this.bookingService.pickerAccept(bookingId, { bookingId, pickerId: userId }).subscribe((res: any) => {
        if (res) {
          const status = res?.data?.status;
          if (status) {
            this.selectedBooking.quickCommerce.status = BookingStatus.PICKER_ACCEPTED;
            this.changeQcBookingStatusEvent.emit(this.selectedBooking);
          }
          this.closeModal();
        }
      });
    }
  }

  userReject(): void {
    if (!this.selectedUser) {
      this.showValidationMessage = true; // Show validation message if no user is selected
      return;
    }
    this.showValidationMessage = false;
    const bookingId = this.selectedBooking._id;
    const userId = this.selectedUser._id;
    if (this.mode === UserType.DRIVER) {
      this.bookingService.driverReject(bookingId, { bookingId, driverId: userId }).subscribe((res: any) => {
        if (res) {
          this.selectedBooking.status = BookingStatus.REJECTED;
          this.changeBookingStatusEvent.emit(this.selectedBooking);
          this.closeModal();
        }
      });
    } else {
      this.bookingService.pickerReject(bookingId, { bookingId, pickerId: userId }).subscribe((res: any) => {
        if (res) {
          this.selectedBooking.quickCommerce.status = BookingStatus.PICKER_REJECTED;
          this.changeQcBookingStatusEvent.emit(this.selectedBooking);
          this.closeModal();
        }
      });
    }
  }

  /**
   * Closes the booking status change confirmation modal.
   */
  closeModal(): void {
    this.acceptRejectModalRef?.dismiss("Cross click");
    this.onReset();
  }

  onReset(): void {
    this.selectedUser = null;
    this.selectedBooking = null;
    this.userList = [];
    this.showValidationMessage = false; // Reset validation message on modal close
  }
}
